module.exports = __webpack_public_path__ + "img/logo.8cb9931.svg";